import { Service, inject } from '@angular/core';
import { Router, type UrlTree } from '@angular/router';
import { map, type Observable } from 'rxjs';

import { UserService } from '../services/user.service';

/** Guard prevents user from accessing if not logged in. */
@Service()
export class UnauthorizedGuard {
	private readonly router = inject(Router);

	/** Whether the user is authorized. */
	private readonly isAuthorized$: Observable<boolean>;

	public constructor() {
		const userService = inject(UserService);

		this.isAuthorized$ = userService.isAuthorized$;
	}

	/** @inheritdoc */
	public canLoad(): Observable<boolean | UrlTree> {
		return this.canNavigate();
	}

	/** @inheritdoc */
	public canActivate(): Observable<boolean | UrlTree> {
		return this.canNavigate();
	}

	/** Determine if /auth route can be activated. */
	private canNavigate(): Observable<boolean | UrlTree> {
		return this.isAuthorized$.pipe(
			map(isAuthorized => isAuthorized ? this.router.parseUrl('/') : true),
		);
	}
}
